<template>
  <span>
    <span @click="dialog = !dialog" style="cursor: pointer; padding: 0 4px">
      {{ this.icon }}
    </span>

    <div v-if="dialog" class="icon-dialog">
      <a
        v-for="(dialogIcon, i) in icons"
        :key="`icon-${i}`"
        href="#"
        class="icon-dialog-icon"
        :class="{ 'icon-active': icon == dialogIcon }"
        @click.prevent="select(dialogIcon)"
        >{{ dialogIcon }}</a
      >
      <input v-model="icon" @input="finish" class="icon-input" />
      <div style="clear: both"></div>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    idea: Object,
  },
  data() {
    return {
      dialog: false,
      icons: [
        '⭐️',
        '🍽',
        '🍷',
        '☕️',
        '🍺',
        '🍸',
        '🍳',
        '🍔',
        '🍕',
        '🌮',
        '🥩',
        '🥗',
        '🐟',
        '🍝',
        '🍣',
        '🍜',
        '🥘',
        '🍦',
        '👀',
        '😂',
        '🎉',
        '🏠',
        '🔥',
        '🎤',
        '🌲',
        '❤️',
        '💙',
        '💚',
        '💛',
        '💜',
        '🖤',
        '✅',
        '🆗',
        '🆒',
      ],
      icon: '⭐️',
    };
  },
  mounted() {
    if (this.idea.icon) {
      this.icon = this.idea.icon;
    }
  },
  computed: {
    ...mapGetters(['list']),
  },
  methods: {
    ...mapActions(['updateIdeaOnList']),
    select(icon) {
      this.icon = icon;
      this.finish();
    },
    finish() {
      this.dialog = false;
      this.updateIcon();
    },
    updateIcon() {
      this.updateIdeaOnList({
        data: {
          icon: this.icon,
        },
        listId: this.list._id,
        ideaId: this.idea.id,
      });
    },
  },
};
</script>

<style scoped>
.icon-dialog {
  background: #f2f2f2;
  border-radius: 8px;
  margin: 8px 0;
}
.icon-dialog-icon {
  cursor: pointer;
  font-size: 24px;
  padding: 8px;
  border-radius: 4px;
  display: block;
  float: left;
  line-height: 1;
}
.icon-active {
  background: #63b3ed;
}
.icon-input {
  display: block;
  float: left;
  font-size: 24px;
  width: 28px;
  height: 28px;
  line-height: 1;
  padding: 2px;
  background: transparent;
  border: solid 1px #ddd;
  border-radius: 4px;
}
@media screen and (min-width: 768px) {
  .icon-dialog {
    margin: 16px 0;
  }
  .icon-dialog-icon {
    font-size: 48px;
    padding: 16px;
  }
  .icon-input {
    font-size: 48px;
    width: 52px;
    height: 52px;
  }
}
</style>



// WEBPACK FOOTER //
// IdeaIcon.vue?0345327c